/* eslint-disable react/jsx-props-no-spreading */
import { Checkbox } from "@adobe/react-spectrum";
import {
  RankedTester,
  RendererProps,
  rankWith,
  uiTypeIs,
} from "@jsonforms/core";
import { useJsonForms, withJsonFormsLayoutProps } from "@jsonforms/react";
import React from "react";

import _, { get } from "lodash";

// Utils
import { useSelector } from "react-redux";
import { evaluateContextRule, extractPath } from "../utils/commonUtils";
import { FormContext } from "../context/FormsContext";

export const compositeCheckboxRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("CompositeCheckbox")
);

function CompositeCheckboxRenderer({ uischema, visible }: RendererProps) {
  const [__, setFormContext] = React.useContext<any>(FormContext);

  const { core } = useJsonForms();
  const data = core?.data || {};

  const label = uischema.options?.label;
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;
  const childrenPath = uischema.options?.childrenPath;

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    const reduxStateData = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxStateData
    )?.visible;
  }

  let isIndeterminate = false;
  let isSelected = true;

  for (let i = 0; i < childrenPath.length; i += 1) {
    const childPath = childrenPath[i];
    const childValue = _.get(data, childPath, false);
    isIndeterminate = isIndeterminate || childValue;
    isSelected = isSelected && childValue;
  }

  const handleChange = (value: boolean) => {
    const childrenObj = childrenPath.reduce((acc: any, item: string) => {
      acc[item] = value;
      return acc;
    }, {});

    setFormContext((oldValues: any) => ({
      ...oldValues,
      data: { ...data, ...childrenObj },
    }));
  };

  return (
    <Checkbox
      onChange={handleChange}
      isSelected={isSelected}
      isIndeterminate={!isSelected && isIndeterminate}
      data-testid="composite-checkbox"
      {...spectrumProps}
      UNSAFE_style={style}
      isHidden={!componentVisibility}
    >
      {label}
    </Checkbox>
  );
}

export default withJsonFormsLayoutProps(CompositeCheckboxRenderer);
